import React from 'react'

const StatusSelect = ({ status, onStatusChange }) => {
  return (
    <select
      aria-label="Scraper status"
      className="rounded-lg border border-rule bg-surface px-2 py-1.5 text-xs text-paper outline-none focus:border-signal"
      defaultValue={status}
      onChange={(event) => onStatusChange(event.target.value)}
    >
      <option value="Active">Active</option>
      <option value="Inactive">Inactive</option>
      <option value="Maintenance">Maintenance</option>
    </select>
  )
}

export default StatusSelect
